<app-breadcrumb *ngIf="!dialogRef"  [master]="'Należności'" [parentName]="'Zestawienia'" [name]="'Dodaj'"></app-breadcrumb>
<div class="statement-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="selection.selected.length <= 0 || processingRequest" [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" *ngIf="!mod">
            <h3>Dodawanie zestawienia</h3>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="!dialogRef">
            <section class="example-section">
              <mat-radio-group   [formControl]="partnerOfwcaControl" fxLayoutGap="15px">
                <mat-radio-button class="example-margin"  value="0" > Partner </mat-radio-button>
                <mat-radio-button class="example-margin"  value="1" > OFWCA </mat-radio-button>
              </mat-radio-group>
            </section>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="!dialogRef">
            <div fxFlex="100" *ngIf="partnerActive && partnerOfwcaControl.value!== null ">
              <app-dict-partners fxFlex="100"  label="Partner" [required]="false" [control]="partnerControl"></app-dict-partners>
            </div>

            <div fxFlex="100" *ngIf="!partnerActive && partnerOfwcaControl.value !== null ">
              <app-dict-ofwcas [control]="ofwcaControl" fxFlex="100" label="OFWCA" [required]="false"></app-dict-ofwcas>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="15px" *ngIf="ofwcaControl.value || partnerControl.value">

            <table mat-table [dataSource]="rows" >

              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()">
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(element) : null"
                                [checked]="selection.isSelected(element)"
                                [aria-label]="checkboxLabel(element)">
                  </mat-checkbox>
                </td>
                <td mat-footer-cell *matFooterCellDef> Kwota należności </td>
              </ng-container>

              <ng-container matColumnDef="ofwca">
                <th mat-header-cell *matHeaderCellDef> Nazwa OFWCA </th>
                <td mat-cell *matCellDef="let element"> {{element.registrationPartner?.ofwcaFullName }}  </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <ng-container matColumnDef="conclusionAt">
                <th mat-header-cell *matHeaderCellDef> Data wystawienia </th>
                <td mat-cell *matCellDef="let element">{{element?.conclusionAt | date:'y-MM-dd'}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <ng-container matColumnDef="customerName">
                <th mat-header-cell *matHeaderCellDef> Nazwa klienta </th>
                <td mat-cell *matCellDef="let element"> {{element?.customerName}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <ng-container matColumnDef="nr">
                <th mat-header-cell *matHeaderCellDef> Numer polisy </th>
                <td mat-cell *matCellDef="let element"> {{element.policyNumber}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <!-- Cost Column -->
              <ng-container matColumnDef="sum">
                <th mat-header-cell *matHeaderCellDef> Kwota </th>
                <td mat-cell *matCellDef="let element"> {{element.amountDue  | number:'1.2-2'}} zł</td>
                <td mat-footer-cell *matFooterCellDef> {{totalAmountDue |  number:'1.2-2'}} zł</td>
              </ng-container>

              <ng-container matColumnDef="tu">
                <th mat-header-cell *matHeaderCellDef> TU </th>
                <td mat-cell *matCellDef="let element"> {{element.registrationPartner?.registrationName}} </td>
                <td mat-footer-cell *matFooterCellDef>  </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr mat-footer-row *matFooterRowDef="displayedColumns "></tr>
            </table>

          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="selection.selected.length <= 0 ||processingRequest " [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

